import React from 'react';
import { Spinner } from '@td-client-frontend/common';

export default function LoadingFallback() {
  return (
    <div className="flex flex-col items-center justify-center flex-1 min-h-full" data-testid="loading-fallback">
      <Spinner />
    </div>
  );
}
